import { inject } from '@angular/core';

import { Store } from '@ngrx/store';

import * as fromStore from '../store';
import { of } from 'rxjs';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';
import { LoadProjects } from 'src/app/projects/store';
import { LoadSprints } from 'src/app/sprints';

export const OpenBacklogItemGuard: CanActivateFn = route => {
  const store = inject(Store);
  const router = inject(Router);
  const activatedRoute = inject(ActivatedRoute);
  const bliId = +route.queryParams['backlogItemId'];

  console.log('OpenBacklogItemGuard', bliId);

  if (bliId > 0) {
    let openItems: number[] = JSON.parse(localStorage.getItem('afterburner:open-items') || '[]');
    let activeItem = bliId;

    // Check if the item is already open
    const activeIndex = openItems.indexOf(+activeItem);
    if (activeIndex === -1) {
      openItems = [...openItems, bliId];
    }

    localStorage.setItem('afterburner:active-item', `${bliId}`);
    localStorage.setItem('afterburner:open-items', JSON.stringify([...openItems]));
  }

  store.dispatch(fromStore.InitOpenBacklogItems({ backlogItemId: bliId }));
  store.dispatch(LoadProjects({ take: 1000, skip: 0 }));
  store.dispatch(LoadSprints({ take: 10, skip: 0 }));

  return true;
};
